/**
 * Whether MSW will be / is being started, mirroring the logic in
 * ``main.tsx``'s ``enableMocking``. Exported so the ``MockBadge`` guard in
 * ``App.tsx`` shows the indicator under the same conditions the worker
 * actually starts. Mocks default OFF; set ``localStorage.msw = "on"`` to
 * force them on.
 */
export function isMswActive(): boolean {
  const persisted = (
    typeof window === "undefined" ? "" : localStorage.getItem("msw") || ""
  )
    .trim()
    .toLowerCase();
  if (persisted === "on") return true;
  return false;
}
